export const checkFileExists = () => {
    throw new Error(`Can't use this function in a web based app`);
};
export const convertAssetToLocalUri = () => {
    throw new Error(`Can't use this function in a web based app`);
};
export const deleteLocalFile = () => {
    throw new Error(`Can't use this function in a web based app`);
};
